import { Link } from 'react-router-dom';
import { 
  CheckCircle2, 
  MessageCircle, 
  Warehouse, 
  Clock, 
  ShieldCheck, 
  ArrowRight, 
  HelpCircle,
  ChevronDown,
  ChevronUp
} from 'lucide-react';
import { useState } from 'react';

export function PromocionPublicaFacilPage() {
  return (
    <div className="bg-white font-sans">
      {/* 1) HERO (PRIMER SCROLL – CRÍTICO) */}
      <section className="relative bg-slate-900 text-white pt-16 pb-20 px-4 md:pt-24 md:pb-32 overflow-hidden">
        {/* Fondo sutil para dar profundidad sin distraer */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#4f46e5_1px,transparent_1px)] [background-size:20px_20px]"></div>
        
        <div className="relative max-w-4xl mx-auto text-center z-10">
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6 leading-tight">
            ¿Tienes un trastero vacío? <br className="hidden md:block" />
            <span className="text-blue-400">Alquílalo fácilmente</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-200 mb-8 font-medium">
            Publica gratis · Contacto directo · Sin comisiones
          </p>
          
          <div className="flex flex-col items-center gap-3">
            <Link 
              to="/publish" 
              className="bg-blue-600 hover:bg-blue-500 text-white text-lg md:text-xl font-bold py-4 px-10 rounded-xl shadow-lg shadow-blue-900/50 transition-all transform hover:scale-105 flex items-center gap-2"
            >
              Publicar gratis
              <ArrowRight className="w-5 h-5" />
            </Link>
            <span className="text-sm text-slate-400 flex items-center gap-1">
              <Clock className="w-3 h-3" /> Tardarás menos de 2 minutos
            </span>
          </div>
        </div>
      </section>

      {/* 2) BENEFICIOS CLAVE */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Beneficio 1 */}
            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-slate-50 border border-slate-100">
              <div className="w-14 h-14 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4">
                <CheckCircle2 className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Gratis de verdad</h3>
              <p className="text-slate-600">
                No cobramos por publicar tu anuncio ni comisiones cuando consigues un inquilino.
              </p>
            </div>

            {/* Beneficio 2 */}
            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-slate-50 border border-slate-100">
              <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
                <MessageCircle className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Contacto directo</h3>
              <p className="text-slate-600">
                Las personas interesadas te escriben directamente a ti. Sin intermediarios.
              </p>
            </div>

            {/* Beneficio 3 */}
            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-slate-50 border border-slate-100">
              <div className="w-14 h-14 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mb-4">
                <Warehouse className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Solo trasteros</h3>
              <p className="text-slate-600">
                Tu anuncio no se pierde entre miles de pisos o locales. Vamos al grano.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3) NORMALIZACIÓN Y CONFIANZA */}
      <section className="bg-slate-50 py-10 px-4 border-y border-slate-100">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-lg md:text-xl font-medium text-slate-700 flex items-center justify-center gap-2">
            <ShieldCheck className="w-6 h-6 text-blue-600" />
            Portal especializado solo en trasteros de particulares
          </p>
        </div>
      </section>

      {/* 4) CÓMO FUNCIONA (SIMPLIFICADO) */}
      <section className="py-16 md:py-24 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-12">Cómo funciona</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {/* Línea conectora (solo desktop) */}
            <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10"></div>

            {/* Paso 1 */}
            <div className="text-center relative bg-white md:bg-transparent">
              <div className="w-16 h-16 bg-slate-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4 shadow-lg">1</div>
              <h3 className="text-lg font-bold mb-2">Publica tu trastero</h3>
              <p className="text-slate-600 text-sm px-4">Formulario sencillo que completas en menos de 2 minutos.</p>
            </div>

            {/* Paso 2 */}
            <div className="text-center relative bg-white md:bg-transparent">
              <div className="w-16 h-16 bg-slate-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4 shadow-lg">2</div>
              <h3 className="text-lg font-bold mb-2">Revisamos el anuncio</h3>
              <p className="text-slate-600 text-sm px-4">Verificamos que todo esté correcto para evitar spam.</p>
            </div>

            {/* Paso 3 */}
            <div className="text-center relative bg-white md:bg-transparent">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4 shadow-lg shadow-blue-200">3</div>
              <h3 className="text-lg font-bold mb-2">Recibe contactos</h3>
              <p className="text-slate-600 text-sm px-4">Te escriben personas interesadas directamente.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 5) QUÉ TIPO DE TRASTEROS SE PUEDEN PUBLICAR */}
      <section className="py-16 px-4 bg-blue-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-blue-100">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8">
              ¿Qué puedes publicar?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-bold text-blue-800 mb-4 flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" /> Tipos de espacio
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    Trasteros en edificios residenciales
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    Trasteros en garajes
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    Trasteros pequeños o grandes
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    De particulares o inmobiliarias
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-blue-800 mb-4 flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" /> Incluso si...
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    Es un espacio pequeño
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    No es obra nueva
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    No está en el centro de la ciudad
                  </li>
                  <li className="flex items-start gap-3 text-slate-700">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 shrink-0"></span>
                    Solo quieres alquilarlo por temporadas
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6) CTA INTERMEDIO */}
      <section className="py-16 px-4 text-center">
        <div className="max-w-2xl mx-auto">
          <Link 
            to="/publish" 
            className="inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-lg font-bold py-4 px-8 rounded-xl transition-all"
          >
            Publicar mi trastero gratis
          </Link>
          <p className="mt-3 text-slate-500 text-sm font-medium">
            Sin comisiones · Contacto directo
          </p>
        </div>
      </section>

      {/* 7) FAQ ORIENTADAS A OBJECIONES */}
      <section className="py-16 px-4 bg-white max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold text-center text-slate-900 mb-10">Preguntas frecuentes</h2>
        <div className="space-y-4">
          <FaqItem 
            question="¿De verdad es gratis?" 
            answer="Sí, 100% gratis. No cobramos por publicar tu anuncio ni te cobramos nada cuando alquilas o vendes tu trastero." 
          />
          <FaqItem 
            question="¿Tengo que pagar comisión si lo alquilo?" 
            answer="No. El trato lo cierras tú directamente con el interesado. Nosotros no intervenimos en el pago ni cobramos comisiones." 
          />
          <FaqItem 
            question="¿Cuánto tarda en publicarse?" 
            answer="Es inmediato. Una vez rellenas el formulario (tardas 2 minutos), tu anuncio pasa una revisión rápida de seguridad y queda visible." 
          />
          <FaqItem 
            question="¿Puedo editar o borrar el anuncio?" 
            answer="Sí, en cualquier momento desde tu panel de usuario puedes modificar el precio, las fotos o borrarlo si ya lo has alquilado." 
          />
          <FaqItem 
            question="¿Quién verá mis datos?" 
            answer="Solo los usuarios registrados en la plataforma pueden ver tus datos de contacto para escribirte o llamarte." 
          />
        </div>
      </section>

      {/* 8) CTA FINAL */}
      <section className="bg-slate-900 text-white py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-8">Empieza a rentabilizar tu espacio</h2>
          <Link 
            to="/publish" 
            className="bg-blue-600 hover:bg-blue-500 text-white text-xl font-bold py-5 px-12 rounded-xl shadow-xl shadow-blue-900/50 transition-all inline-flex items-center gap-2"
          >
            Publicar gratis
          </Link>
          <p className="mt-6 text-slate-400">
            Publicar es gratis y no tiene compromiso
          </p>
        </div>
      </section>
    </div>
  );
}

function FaqItem({ question, answer }: { question: string, answer: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-5 text-left bg-slate-50 hover:bg-slate-100 transition-colors"
      >
        <span className="font-semibold text-slate-900">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-slate-500" /> : <ChevronDown className="w-5 h-5 text-slate-500" />}
      </button>
      {isOpen && (
        <div className="p-5 bg-white text-slate-600 border-t border-slate-100">
          {answer}
        </div>
      )}
    </div>
  );
}
